import { connect } from 'react-redux';
import { logout } from '../../auth/actions';
import * as actions from '../components/SurveyBuilderPage/SurveyBuilder/state/actions';
import SurveyBuilderPage from '../components/SurveyBuilderPage/SurveyBuilderPage';

const mapStateToProps = state => ({
  isAdmin: state.auth.isAdmin,
  isAuthenticated: state.auth.isAuthenticated,
  isProfilingTagsManager: state.auth.isProfilingTagsManager,
  clientEmail: state.auth.clientEmail,
  surveysState: state.surveys
});

const mapDispatchToProps = dispatch => ({
  onLogout: () => dispatch(logout()),
  emptySurveyState: () => dispatch(actions.emptySurveyState()),
  updateDecisionFramework: (api, question) =>
    dispatch(actions.updateDecisionFramework(api, question))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SurveyBuilderPage);
